import { render, staticRenderFns } from "./account-menu.vue?vue&type=template&id=acd489fc"
import script from "./account-menu.vue?vue&type=script&lang=js"
export * from "./account-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports